import {LOB_LIST, LOB_UPDATE, LOB_DELETE, DEPARTMENT_SELECT, PL_PROFILE_SELECT} from './../actions/ActionTypes';
import InitialState from './InitialState';


const OrganicGrowthWizardReducer = (state = InitialState.organicGrowthWizard, action) => {
    switch (action.type) {
        case LOB_LIST: {
            let data = Object.assign({}, state);
            data.lobList = action.lobListData;

            return data;
        }

        case DEPARTMENT_SELECT: {
            let data = Object.assign({}, state);

            data.selectedDepartmetId = action.selectedDepartmentId;

            return data;
        }

        case PL_PROFILE_SELECT: {
            let data = Object.assign({}, state);

            data.selectedPlProfile = action.selectedPlProfile;

            return data;
        }

        case LOB_UPDATE: {
            let data = Object.assign({}, state);

            data.lobList = state.lobList.map((item) => (
                item.id === action.lobData.id ? action.lobData : item
            ));
            return data
        }

        case LOB_DELETE: {
            let data = Object.assign({}, state);

            data.lobList = state.lobList.filter((item) => (
                item.id !== action.lobId
            ));
            return data
        }

        default:
            return state;
    }
};
export default OrganicGrowthWizardReducer;



// WEBPACK FOOTER //
// ./src/reducers/OrganicGrowthWizardReducer.js